import * as $ from 'jquery';

export class DropdownCommon {
    static init(component) {
        $(component).find('.dropdown-item').click(ev => {
            let item = $(ev.target).closest('.dropdown-item');
            let value = item.attr('data-value');
            let text = item.text();
            let parent = item.closest('.dropdown-component');
            parent.find('.dropdown-toggle').text(text);
            parent.find('input').val(value).attr('data-dirty', 'true').blur();
        })

    }
}